import {
  withCompInfo,
  createComponentMapperModel,
  withStateRefsValues,
} from '@wix/editor-elements-integrations';
import type {
  ISlideshowDefinition,
  ISlideshowMapperProps,
  ISlideshowCarmiProps,
} from '../../types';
import type { TransitionDirection } from '../../constants';
import { TranslationKeysViewer, Transition } from '../../constants';
import { getAnimations, getSlideVariables } from '../utils/animations';
import { castFromInheritIfNeeded } from '@wix/editor-elements-common-utils';

export const props = withCompInfo<
  ISlideshowMapperProps,
  ISlideshowDefinition,
  ISlideshowCarmiProps
>()(
  ['compProps', 'compData', 'directionWithOptInRtlSupport', 'translate'],
  (
    { compProps, compData, directionWithOptInRtlSupport, translate },
    carmiData,
  ) => ({
    ...carmiData,
    ...compProps,
    direction: castFromInheritIfNeeded(
      compData?.direction,
      directionWithOptInRtlSupport,
    ),
    currentIndex: 0,
    navigatingForward: true,
    initialIsPlaying: compProps.isPlaying,
    translations: {
      playControlAriaLabel: translate(
        TranslationKeysViewer.namespace,
        TranslationKeysViewer.playControlAriaLabel,
      ),
      pauseControlAriaLabel: translate(
        TranslationKeysViewer.namespace,
        TranslationKeysViewer.pauseControlAriaLabel,
      ),
    },
  }),
);

export const stringToBool = (value: string): boolean => {
  return value === 'true';
};

export const css = withCompInfo()(
  ['styleProperties', 'compData', 'directionWithOptInRtlSupport'],
  ({ styleProperties, compData, directionWithOptInRtlSupport }) => {
    const {
      showNavButtons,
      showDisabledNavButtons,
      transitionEffect,
      transitionDuration,
      transitionDirection,
    } = styleProperties as Record<string, string>;

    const direction = castFromInheritIfNeeded(
      compData?.direction,
      directionWithOptInRtlSupport,
    );

    return {
      '--navBtnVisibility': stringToBool(showNavButtons) ? 'visible' : 'hidden',
      ...(stringToBool(showDisabledNavButtons) === false && {
        '--disabledNavBtnVisibility': 'hidden',
      }),
      '--transitionDuration':
        transitionEffect === Transition.None ? 0 : transitionDuration,
      ...getAnimations(transitionEffect as Transition),
      ...(transitionEffect === Transition.Slide &&
        getSlideVariables(
          transitionDirection as TransitionDirection,
          direction,
        )),
    };
  },
);
export const stateRefs = withStateRefsValues(['reducedMotion']);

export default createComponentMapperModel({ props, css, stateRefs });
